import React from 'react';
export function EditorAnchorLinkIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 7.83a3.001 3.001 0 10-2 0V10H7v2h4v7.93A7.001 7.001 0 015 13H3a9 9 0 1018 0h-2a7.001 7.001 0 01-6 6.93V12h4v-2h-4V7.83z"
  }));
}